export default {
  methods: {
    validateWithScroll () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$nextTick(() => {
          let incorrectInput = document.querySelector('input.error, select.error, textarea.error')
          if (incorrectInput) {
            let incorrectLabel = incorrectInput.parentNode.parentNode.querySelector('.label')
            if (incorrectLabel) {
              incorrectLabel.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'})
            } else {
              incorrectInput.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'})
            }
          }
        })
      }
    }
  }
}
